var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _path, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _path2, _line31, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _line32, _line33, _polygon39, _polygon40, _line34, _line35;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Str1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: none;\n        stroke-width: 5px;\n      }\n\n      .cls-1 {\n        stroke: #39a935;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #39a935;\n        stroke: #1d1d1b;\n        stroke-width: 0.5px;\n      }\n\n      .cls-3 {\n        stroke: #3aaa35;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 522.26,
    y1: 51.74,
    x2: 527,
    y2: 417
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 524.84,
    y1: 51.76,
    x2: 395.36,
    y2: 51.24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 522.6,
    y1: 77.38,
    x2: 465.9,
    y2: 77.39
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 397.9,
    y1: 51.5,
    x2: 399.45,
    y2: 215.71
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 398.4,
    y1: 103.71,
    x2: 500.35,
    y2: 103.71
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 524.68,
    y1: 215.18,
    x2: 396.91,
    y2: 215.71
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 522.26,
    y1: 51.74,
    x2: 584.74,
    y2: 51.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 584.23,
    y1: 5.54,
    x2: 584.23,
    y2: 54.06
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 504.36,
    y1: 215.27,
    x2: 504.36,
    y2: 178.8
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 504.55,
    y1: 215.26,
    x2: 504.55,
    y2: 253.65
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 526.3,
    y1: 363.06,
    x2: 472.48,
    y2: 363.32
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 472.48,
    y1: 360.82,
    x2: 473.26,
    y2: 402.37
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 472.87,
    y1: 386.06,
    x2: 194.94,
    y2: 385.68
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 194.64,
    y1: 388.09,
    x2: 194.25,
    y2: 369.51
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.68,368.87l-52.26.58q-.39,8.32-.77,16.65"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 222.03,
    y1: 385.72,
    x2: 222.42,
    y2: 408.35
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 219.71,
    y1: 407.97,
    x2: 278.94,
    y2: 408.74
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 249.32,
    y1: 406.05,
    x2: 249.32,
    y2: 443.59
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 280.87,
    y1: 406.25,
    x2: 280.48,
    y2: 456.95
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 219.71,
    y1: 407.97,
    x2: 185.65,
    y2: 408.35
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 386.55,
    y1: 385.94,
    x2: 354.81,
    y2: 411.06
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 355.81,
    y1: 411.06,
    x2: 318.26,
    y2: 410.68
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 349,
    y1: 408.55,
    x2: 349.39,
    y2: 457.85
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 318.42,
    y1: 408.21,
    x2: 318.55,
    y2: 464.09
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 181.77,
    y1: 163.71,
    x2: 181.77,
    y2: 313.13
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.45,
    y1: 313.13,
    x2: 285.9,
    y2: 313.13
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 285.9,
    y1: 268.58,
    x2: 285.9,
    y2: 315.42
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.45,
    y1: 166.13,
    x2: 288.61,
    y2: 108.84
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 286.9,
    y1: 108.81,
    x2: 307.81,
    y2: 108.81
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 307.81,
    y1: 111.27,
    x2: 306.03,
    y2: 6.13
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.45,
    y1: 313.13,
    x2: 162.55,
    y2: 313.13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "526.64 397.38 536.16 380.88 517.11 380.88 526.64 397.38"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "526.08 354.22 535.61 337.72 516.55 337.72 526.08 354.22"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.2 285.08 191.73 268.58 172.68 268.58 182.2 285.08"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.77 229.43 191.3 212.93 172.25 212.93 181.77 229.43"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "181.77 179.11 191.3 162.61 172.25 162.61 181.77 179.11"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "524.63 269.02 534.16 252.52 515.11 252.52 524.63 269.02"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "524.97 269.02 534.5 252.52 515.45 252.52 524.97 269.02"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "523.91 189.8 533.44 173.3 514.38 173.3 523.91 189.8"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "504.55 200.8 514.08 184.3 495.02 184.3 504.55 200.8"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "398.68 194.25 408.2 177.75 389.15 177.75 398.68 194.25"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "553.29 51.69 536.67 42.38 536.91 61.43 553.29 51.69"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "494.25 77.17 477.63 67.86 477.87 86.91 494.25 77.17"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "442.57 215.05 425.95 205.74 426.2 224.79 442.57 215.05"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "267.16 312.92 250.54 303.6 250.78 322.65 267.16 312.92"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "515.36 215.3 498.73 205.99 498.98 225.04 515.36 215.3"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.82 103.81 488.32 113.34 488.32 94.29 471.82 103.81"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "421.3 103.81 437.8 113.34 437.8 94.29 421.3 103.81"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "372.53 385.87 389.03 395.4 389.03 376.35 372.53 385.87"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.2 313.13 187.7 322.65 187.7 303.6 171.2 313.13"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.18 386.1 280.68 395.62 280.68 376.57 264.18 386.1"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "168.76 368.87 185.26 378.4 185.26 359.35 168.76 368.87"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.65 381.38 153.17 364.88 134.12 364.88 143.65 381.38"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "398.68 69.2 389.15 85.7 408.2 85.7 398.68 69.2"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.94 233.36 496.33 246.64 511.54 246.64 503.94 233.36"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "584.23 12.04 574.7 28.54 593.75 28.54 584.23 12.04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.39,415.68q-14,27.29-28.07-.39"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 499.57,
    y1: 416.89,
    x2: 499.68,
    y2: 406.85
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "499.62 401.54 490.09 418.04 509.15 418.04 499.62 401.54"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.82 373.37 462.29 389.87 481.35 389.87 471.82 373.37"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "349.22 427.83 339.69 444.33 358.74 444.33 349.22 427.83"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "285.9 268.58 276.38 285.08 295.43 285.08 285.9 268.58"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "306.43 21.55 296.9 38.05 315.96 38.05 306.43 21.55"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "306.43 68.61 296.9 85.11 315.96 85.11 306.43 68.61"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "221.64 145.28 240.66 144.06 230.09 128.2 221.64 145.28"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.05 117.25 294.07 116.03 283.5 100.17 275.05 117.25"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "318.48 427.83 308.96 444.33 328.01 444.33 318.48 427.83"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "280.68 418.04 271.15 434.54 290.2 434.54 280.68 418.04"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.32 420.6 239.8 437.1 258.85 437.1 249.32 420.6"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.19 389.53 215.58 400.79 228.81 400.79 222.19 389.53"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "204.93 408.16 188.43 398.63 188.43 417.69 204.93 408.16"
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.26,
    y1: 282.84,
    x2: 497.64,
    y2: 282.84
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 523.46,
    y1: 144.16,
    x2: 494.25,
    y2: 143.97
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "508.49 283.69 495.28 276.94 495.46 290.78 508.49 283.69"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.55 363.02 490.34 356.27 490.52 370.11 503.55 363.02"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 506.88,
    y1: 176.32,
    x2: 475.72,
    y2: 176.32
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 507.08,
    y1: 253.65,
    x2: 475.92,
    y2: 253.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Str1);
export default __webpack_public_path__ + "static/media/-1 str_Монтажная область 1.2a2884c993fcefbe2aecacfb88f96620.svg";
export { ForwardRef as ReactComponent };